import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { MessageCircle, FileText } from 'lucide-react';
import Hero from '../components/Hero';
import WhyChoose from '../components/WhyChoose';
import Products from '../components/Products';
import HowToOrder from '../components/HowToOrder';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-cream">
      <Hero />
      <WhyChoose />
      <Products />
      <HowToOrder />
      
      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-br from-burgundy to-burgundy-dark text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Commandez dès maintenant
          </h2>
          <p className="text-lg mb-4 text-gray-200 max-w-2xl mx-auto">
            Contactez-nous via WhatsApp pour une réponse rapide ou utilisez notre formulaire de commande en ligne
          </p>
          
          {/* Contact Numbers */}
          <div className="flex flex-wrap gap-3 justify-center mb-8 text-sm">
            <a href="tel:+221781270846" className="text-gold hover:text-white transition-colors">
              📞 +221 78 127 08 46
            </a>
            <span className="text-gray-400">|</span>
            <a href="tel:+221779093914" className="text-gold hover:text-white transition-colors">
              📞 +221 77 909 39 14
            </a>
            <span className="text-gray-400">|</span>
            <a href="mailto:sales@volailleprime.com" className="text-gold hover:text-white transition-colors">
              ✉️ sales@volailleprime.com
            </a>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="https://wa.me/221781270846?text=Bonjour,%20je%20souhaite%20commander%20des%20poulets"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block"
            >
              <Button 
                size="lg" 
                className="w-full sm:w-auto bg-green-600 hover:bg-green-700 text-white gap-2 shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105"
              >
                <MessageCircle size={20} />
                Commander sur WhatsApp
              </Button>
            </a>
            <Link to="/produits">
              <Button 
                size="lg" 
                variant="outline"
                className="w-full sm:w-auto bg-white text-burgundy hover:bg-gray-100 border-white gap-2 shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105"
              >
                <FileText size={20} />
                Formulaire de commande
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Home;
